import { render, staticRenderFns } from "./TreatmentFrequency.vue?vue&type=template&id=f15ff600&scoped=true&lang=pug&"
import script from "./TreatmentFrequency.vue?vue&type=script&lang=js&"
export * from "./TreatmentFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15ff600",
  null
  
)

export default component.exports